import React, { useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import {
  agendaCitaTipoLabel,
  formatAgendaPrecio,
  formatSlotLabel,
  MENSAJE_PAGO_24H,
  registerAgendaPayment,
} from '../services/agendaService';
import { getUserSession } from '../services/authService';
import '../styles/agenda.css';

const AgendaPaymentPage = () => {
  const history = useHistory();
  const location = useLocation();
  const pago = location.state || {};
  const cita = pago.cita || null;
  const booking = pago.booking || null;
  const sessionUser = getUserSession();
  const sessionUserId = sessionUser ? sessionUser.id : null;

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const volverAlCalendario = (extraState) => {
    history.push({
      pathname: '/agenda/calendario',
      state: {
        ...(booking || {}),
        ...(extraState || {}),
      },
    });
  };

  const handleConfirmPayment = () => {
    if (!cita || !sessionUserId || saving) {
      return;
    }

    setSaving(true);
    setError('');

    registerAgendaPayment({
      solicitante_id: sessionUserId,
      cita_id: cita.id,
    })
      .then(() => {
        volverAlCalendario({
          pagoCompletado: true,
          slotPagado: {
            fecha: cita.fecha,
            hora: cita.hora,
          },
        });
      })
      .catch((err) => {
        const mensaje = err.message || 'No se pudo registrar el pago.';

        if (mensaje.indexOf('pagó primero') !== -1) {
          volverAlCalendario({ horarioTomado: mensaje });
          return;
        }

        setError(mensaje);
        setSaving(false);
      });
  };

  if (!cita || !cita.id) {
    return (
      <div className="agenda-root agenda-root--booking">
        <section className="agenda-booking">
          <div className="agenda-payment-card">
            <h1>Pago de prueba</h1>
            <p>No hay una cita pendiente para pagar. Vuelve al calendario y pulsa Pagar.</p>
            <Link to="/agenda" className="agenda-calendar-back">
              ← Volver a la agenda
            </Link>
          </div>
        </section>
      </div>
    );
  }

  const horario = formatSlotLabel(cita.fecha, cita.hora);

  return (
    <div className="agenda-root agenda-root--booking">
      <section className="agenda-booking">
        <div className="agenda-payment-card">
          <p className="agenda-payment-badge">Pago de prueba</p>
          <h1>Pasarela de pago</h1>
          <p>
            Este cobro es ficticio. No se realiza ningún cargo. Sirve para completar el proceso
            hasta conectar la pasarela con la que quedará el proyecto.
          </p>
          <p className="agenda-cita-pay-notice" role="status">
            {MENSAJE_PAGO_24H}
          </p>

          <dl className="agenda-payment-summary">
            <div>
              <dt>Tipo de cita</dt>
              <dd>{agendaCitaTipoLabel(cita.tipo_cita)}</dd>
            </div>
            <div>
              <dt>Horario</dt>
              <dd>{horario}</dd>
            </div>
            {formatAgendaPrecio(cita.precio, cita.moneda) ? (
              <div>
                <dt>Precio</dt>
                <dd>
                  {formatAgendaPrecio(cita.precio, cita.moneda)}
                  {cita.servicio_nombre ? ` · ${cita.servicio_nombre}` : ''}
                </dd>
              </div>
            ) : null}
            {booking && booking.specialist ? (
              <div>
                <dt>Especialista</dt>
                <dd>{booking.specialist.label}</dd>
              </div>
            ) : null}
            {pago.pacienteNombre ? (
              <div>
                <dt>Paciente</dt>
                <dd>{pago.pacienteNombre}</dd>
              </div>
            ) : null}
          </dl>

          {error ? (
            <p className="agenda-event-patient-hint agenda-event-patient-hint--error" role="alert">
              {error}
            </p>
          ) : null}

          <div className="agenda-slot-actions">
            <button
              type="button"
              className="agenda-slot-pay-btn"
              onClick={handleConfirmPayment}
              disabled={saving}
            >
              {saving ? 'Registrando pago…' : 'Confirmar pago de prueba'}
            </button>
            <button
              type="button"
              className="agenda-slot-secondary-btn"
              onClick={() => volverAlCalendario()}
              disabled={saving}
            >
              Volver sin pagar
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AgendaPaymentPage;
